"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HTMLeditor = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _ckeditor4React = require("ckeditor4-react");

var _config = _interopRequireDefault(require("./_config"));

var _classnames = _interopRequireDefault(require("classnames"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

const HTMLeditor = ({
  text,
  onTextChange,
  onTextChangeHTML,
  classNames,
  ...rest
}) => {
  const [editorValue, setEditorValue] = (0, _react.useState)(text || '');
  const [editorInstance, setInstance] = (0, _react.useState)(null);

  const getSimpleText = () => {
    return editorInstance && editorInstance.instances && editorInstance.instances.customEditor && editorInstance.instances.customEditor.document && editorInstance.instances.customEditor.document.getBody() && editorInstance.instances.customEditor.document.getBody().getText();
  };

  const onEditorTextChange = e => {
    const data = e.editor.getData();
    setEditorValue(data);
  };

  (0, _react.useEffect)(() => {
    // Simple text callback
    if (onTextChange && typeof onTextChange === 'function') {
      let simpleText = getSimpleText();

      if (!simpleText) {
        simpleText = editorValue;
      }

      onTextChange(simpleText);
    } // HTML text callback


    if (onTextChangeHTML && typeof onTextChangeHTML === 'function') {
      onTextChangeHTML(editorValue);
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [editorInstance, editorValue]);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: classNames ? (0, _classnames.default)('custom-editor-wrapper', classNames) : 'custom-editor-wrapper'
  }, /*#__PURE__*/_react.default.createElement(_ckeditor4React.CKEditor, _extends({
    name: "customEditor",
    config: _config.default,
    initData: editorValue,
    onBeforeLoad: instance => setInstance(instance),
    onChange: onEditorTextChange
  }, rest)));
};

exports.HTMLeditor = HTMLeditor;
HTMLeditor.defaultProps = {
  text: 'This is sample text',
  classNames: ''
};
HTMLeditor.propTypes = {
  /** Initial text data*/
  text: _propTypes.default.string,

  /** Function when data in changed. Called with 1 argument i.e HTML text data */
  onTextChangeHTML: _propTypes.default.func,

  /** Function when data in changed. Called with 1 argument i.e Simple text data */
  onTextChange: _propTypes.default.func,

  /** List of space separated class names for adding custom classes*/
  classNames: _propTypes.default.string
};